// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e2538ca2","239":"6f254b0c","455":"2eefbe6a"}[chunkId] + ".chunk.js";
};